// :cow: Cosmose CONFIDENTIAL :iso:
import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from 'saturn-datepicker';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { Observable, Subject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { State } from './store';
import { datepickerFormat } from '../utils';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { LanguageService } from '@med/app/core/language/service/language.service';
import { ConfigService } from '@med/app/core/config/config.service';
import { NgxSpinnerService } from 'ngx-spinner';

declare let loadHotjar: any;

@Component({
  selector: 'e-app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [
    {provide: MAT_DATE_LOCALE, useValue: 'en-GB'},
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_FORMATS, useValue: datepickerFormat},
  ],
})
export class AppComponent implements OnInit, OnDestroy, AfterViewInit {
  isPending$: Observable<boolean>;
  isAdblockPopupActive = false;
  adblockPopupShouldExist = true;

  private unsubscribe$ = new Subject<void>();

  constructor(
    private store: Store<State>,
    private adapter: DateAdapter<any>,
    private translate: TranslateService,
    private changeDetectorRef: ChangeDetectorRef,
    private languageService: LanguageService,
    private configService: ConfigService,
    private spinner: NgxSpinnerService,
  ) {
  }

  ngOnInit() {
    this.getPendingState();
    this.changeDetectorRef.detectChanges();
    this.initLocale();
    this.initLanguage();

    if (window['noAdBlocking']) {
      this.adblockPopupShouldExist = false;
    } else {
      this.isAdblockPopupActive = true;
    }

    this.loadExternalScripts();
  }


  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  reload() {
    window.location.reload();
  }

  ngAfterViewInit() {
    this.changeDetectorRef.detectChanges();
  }

  getPendingState() {
    this.spinner.getSpinner('primary')
      .subscribe(() => {
        this.changeDetectorRef.detectChanges();
      });
  }

  async loadExternalScripts() {
    const hotjarClientId = this.configService.getConfig().hotjarClientId;
    if (hotjarClientId) {
      loadHotjar(hotjarClientId);
    }
  }

  private initLocale(): void {
    this.languageService
      .getLanguage()
      .pipe(filter((value) => !!value))
      .subscribe((code) => this.adapter.setLocale(code));

    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.adapter.setLocale(event.lang);
    });
  }

  private initLanguage(): void {
    this.languageService.initLanguage();
  }
}
